// extracted by mini-css-extract-plugin
module.exports = {"bildesveip":"dhsg20kzm-bildesveip","bildesveip__bildewrapper":"dhsg3TCq4-bildesveip__bildewrapper","bildesveipBildewrapper":"dhsg3TCq4-bildesveip__bildewrapper"};